import { deletePaymentCard } from "../../../../app/api/deletePaymentCard";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { IDeletePaymentCardActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/PaymentCardsActionParams";
import { _eventBus } from "../../../../core/events/EventBus";
import { myAccountTree } from "../../../../Orchestrator/ConstantTree";
import { showNotification } from "../../../../Services/notificationService";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";


class DeletePaymentCardAction extends BaseAction<{ result: string, data: any }, IDeletePaymentCardActionParams> {

    override async run(): Promise<{ result: string, data: any }> {
        try {
            const { userId, paymentCardId } = this.params!;
            let data;
            if (userId && paymentCardId) {
                const response: any = await deletePaymentCard(userId, paymentCardId);
                if (response.status === "ok") {
                    _eventBus.emit({
                        eventName: myAccountTree.paymentCards.Get,
                    });
                    showNotification("info", getTranslatedMessage("cardDeleted"), getTranslatedMessage("cardDelSuccess"), 3);
                    data = { success: true };
                } else {
                    data = { success: false, error: "Failed to delete card" };
                }
            }
            let responseData = {
                result: data?.success ? "true" : "false",
                data: data
            }
            return responseData;
        } catch (error: any) {
            let responseData = {
                result: "false",
                data: { success: false, error: error?.message || "Error deleting card" }
            }
            return responseData;
        }
    }
}

export const deletePaymentCardAction = new DeletePaymentCardAction()


